import Base from './base';

import './component.scss';

export class RetailcrmSubscribe extends Base {
    constructor(id, params = {}, result = {}, options = {}) {
        super(id, params, result, options)

        this.init()
    }

    init() {
        this.addEventListeners()
    }

    addEventListeners() {
        let self = this

        document.on('click', '.js-subscribe-form-button', e => {
            if (true === this.checkForm()) {
                self.subscribe()
            } else {
                this.showModal('Ошибка', 'Для продолжения вам необходимо согласиться на обработку персональных данных')
            }
        })
    }

    checkForm() {
        let $checkbox = this.$component.querySelector('.js-agree_checkbox_privacy')

        if (!$checkbox) {
            return true
        }

        if (true === $checkbox.checked) {
            return true
        }

        return false
    }

    async subscribe() {
        let resultData = null,
            email = this.$component.querySelector('.js-subscribe-form-input').value

        resultData = await this.queryComponent('subscribe', {
            email,
        })

        if (resultData.success === true) {
            if (true === resultData?.subscribeBefore) {
                this.showModal('С возвращением!', 'Оплачивайте заказ онлайн и получите скидку 5%.')
            } else {
                this.showModal('Спасибо!', 'Вам на e-mail направлено письмо с промокодом на скидку 10%.')
                ym(20318386, 'reachGoal', 'mailing')
            }
        } else {
            this.showModal('Ошибка', resultData.message)
        }
    }

    showModal(title, text) {
        let $modal = this.$component.querySelector('.js-subscribe-modal')
        if (!$modal) {
            return
        }

        $modal.querySelector('.js-subscribe-modal-header').innerHTML = title
        $modal.querySelector('.js-subscribe-modal-text').innerHTML = text

        Fancybox.show(
            [
                {
                    src: `#${this.id}__modal-subscribe`,
                    type: "inline",
                },
            ],
            {
                mainClass: 'modal-subscribe',
            }
        );
    }
}
